var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.computedItems.length)?_c('splide',{ref:"slide",attrs:{"slides":_vm.computedItems,"options":_vm.computedOptions},on:{"splide:mounted":_vm.ready}},_vm._l((_vm.computedItems),function(item,index){return _c('splide-slide',{key:_vm.key(item[index])},[_vm._t("default",null,null,{ items: item, item, index })],2)}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }